export const TEMPLATE_TYPES = {
  DEFAULT: 'default',
  TASK: 'task',
};

export const TEMPLATE_TO_TYPES = {
  AGENT: 'Agent',
  CLIENTS: 'Client(s)',
  COORDINATOR: 'Coordinator',
};

export const BLANK_TEMPLATE_TITLE = 'Blank Template';

export const COMMON_TEMPLATE_TITLES = {
  BLANK_TEMPLATE: 'Blank Template',
  WELCOME_THE_CLIENT: 'Welcome the client and introduce yourself',
  YOUR_LISTING_IS_LIVE: 'Your listing is live',
  YOUR_HOME_IS_UNDER_CONTRACT: 'Your home is under contract',
  FROM_SELLING_AGENT: 'From Selling agent - Home seller',
  BUYING_AGENT: 'Buying agent - Home buyer',
  BUYER_CLOSING_INSTRUCTIONS: 'Buyer - Closing Instructions Email',
  REFERRAL_ASK: 'Referral ask',

  // New templates
  ALL_PARTIES: 'All Parties Email',
  BUYER_POST_CLOSING_AGENT_REVIEW_REQUEST: 'Buyer - Post Closing Agent Review Request',
  SELLER_CANCEL_CHANGE_UTILITIES: 'Seller - Cancel/Change Utilities',
  SELLER_CLOSING_REMINDER_EMAIL: 'Seller - Closing Reminder Email',
  SELLER_PHOTO_SHOOT_SCHEDULE: 'Seller - Photoshoot Scheduled',
  SELLER_SETTLEMENT_STATEMENT_EMAIL: 'Seller - Settlement Statement Email',
  UPCOMING_INSPECTION_REMINDER: 'Upcoming Inspection Reminder',
};
